export default "__VITE_ASSET__Ba04sRSq__"